import React from 'react';

interface LogoViewProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  alt?: string;
  width?: string | number;
  height?: string | number;
  className?: string;
  fallback?: React.ReactNode;
}

export const LogoView: React.FC<LogoViewProps> = ({
  src,
  alt = 'Imagen',
  width = 'auto',
  height = 'auto',
  className = '',
  fallback = null,
  ...props
}) => {
  return <img src={src} alt={alt} width={width} height={height} className={className} {...props} />;
};
